import { Component, effect, Signal, signal } from '@angular/core';
import { AuthenticationService, QuotationCartService } from '@app/_services';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ConfirmDialogComponent } from '@app/shared/components/confirm-dialog/confirm-dialog.component';
import { Router, RouterLinkActive, RouterLink, RouterOutlet } from '@angular/router';
import { SiteService } from '@app/_services/site.service';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf, NgFor } from '@angular/common';
import { GeneralNavigationService } from '@app/_components/root/general-navigation/general-navigation.service';
import { listGroup, listItem } from '@app/_components/root/general-navigation/list-items.interface';
import { SharedService } from '@app/_services/shared.service';
import { QBreadcrumbsComponent } from '../breadcrumbs/breadcrumbs.component';
import { QBreadcrumbsService, TQBreadCrumbs } from '../breadcrumbs/breadcrumbs.service';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, RouterLinkActive, RouterLink, RouterOutlet, TranslateModule, QBreadcrumbsComponent]
})
export class LayoutComponent {
    breadcrumbs: Signal<TQBreadCrumbs> = signal([]);
    constructor(private authService: AuthenticationService,
        private modalService: BsModalService,
        private router: Router,
        private qBreadcrumbsService: QBreadcrumbsService,
        private quotationCartService: QuotationCartService,
        private generalNavigationService: GeneralNavigationService,
        private sharedService: SharedService,
        public siteService: SiteService) {
        this.sharedService.location = 'rfq';
        this.breadcrumbs = this.qBreadcrumbsService.breadCrumbs;


        effect(() => {
            this.generalNavigationService.menuItems = [
                {
                    items: [
                        {
                            label: 'quotes_center',
                            shortLabel: 'center',
                            icon: 'fa-arrows-to-circle',
                            iconType: 'fa',
                            routerLink: './rfq/center'
                        },
                        {
                            label: 'dashboard',
                            shortLabel: 'dashboard',
                            icon: 'fa-table-columns',
                            iconType: 'fa',
                            routerLink: './rfq/dashboard'
                        },
                        {
                            label: 'BoQ Projects',
                            shortLabel: 'boq_Projects',
                            icon: 'fa-file-invoice',
                            iconType: 'fa',
                            routerLink: './boq-projects'
                        },
                        {
                            label: 'quotation_requests',
                            shortLabel: 'rfq_list',
                            icon: 'receipt_long',
                            iconType: 'material',
                            routerLink: './rfq/request'
                        },
                        
                        {
                            label: 'RFQ_List',
                            shortLabel: 'mylist',
                            icon: 'fa-rectangle-list',
                            ...(this.notifications()?.quote
                                ? {
                                      badge: {
                                          type: 'number',
                                          value: this.notifications().quote
                                              .length
                                      }
                                  }
                                : {}),
                            iconType: 'fa',
                            routerLink: './rfq/list'
                        },
                        {
                            label: 'my_items',
                            shortLabel: 'items',
                            icon: 'fa-trowel-bricks',
                            iconType: 'fa',
                            routerLink: './rfq/items'
                        },
                        {
                            label: 'addresses',
                            shortLabel: 'addresses',
                            icon: 'pin_drop',
                            iconType: 'material',
                            routerLink: './rfq/addresses'
                        },
                        {
                            label: 'hookworks',
                            shortLabel: 'hook_works',
                            icon: 'fa-pen-to-square',
                            iconType: 'fa',
                            routerLink: './rfq/projects'
                        },
                        // {
                        //     label: 'BOQ',
                        //     shortLabel: 'boq',
                        //     icon: 'fa-file-invoice',
                        //     iconType: 'fa',
                        //     routerLink: './boq'
                        // },
                    ]
                },
                {
                    items: [
                        {
                            label: 'go_homepage',
                            shortLabel: 'homepage',
                            icon: 'undo',
                            iconType: 'material',
                            routerLink: './'
                        }
                    ]
                }
            ];
        }, { allowSignalWrites: true })

    }

    notifications = this.authService.notifications;
    public navigationItems: listGroup[];


    userDetails;
    bsModalRef: BsModalRef;
    quantity;

    logout() {
        this.bsModalRef = this.modalService.show(ConfirmDialogComponent, { class: 'modal-sm' });
        this.bsModalRef.content.onClose.subscribe((confirmed) => {
            if (confirmed) {
                this.authService.logout().subscribe(res => {
                    res
                });
                this.router.navigate(['/'])
            }
        });
    }

    ngOnInit() {
        this.quotationCartService.quantity$.subscribe(quantity => {
            this.quantity = quantity;
        });



    }

    ngOnDestroy(): void {
        this.generalNavigationService.menuState = false;
        this.generalNavigationService.menuItems = [];
        this.sharedService.location = null;
    }
}
